import { GetterTree } from "vuex";
import { ICostCenterState } from "../types";
import { StoreState } from "@/store/type";
import { ICostCenter } from "@/core/interfaces/costCenter.interface";

const getters: GetterTree<ICostCenterState, StoreState> = {
  costCenters: (state): ICostCenter[] => state.costCenters,
  isFetchingCostCenters: (state): boolean => state.isFetchingCostCenters,
  costCenterActionLoading: (state): boolean => state.costCenterActionLoading,
};

export default getters;
